import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37ef3530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "umbraco-form-fieldset umbraco-forms-fieldset" }

import { PropType } from "vue";
import { IUmbracoFormFieldset } from "@/models/umbraco-forms/IUmbracoFormFieldset";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormFieldset',
  props: {
  fieldset: {
    type: Object as PropType<IUmbracoFormFieldset>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", { fieldset: __props.fieldset })
  ]))
}
}

})